import {styled} from "@mui/system";
import {IconButton, Typography} from "@mui/material";
import MinusIcon from "assets/icons/MinusIcon";
import SimpleAddIcon from "assets/icons/SimpleAddIcon";
import {useFormikContext} from "formik";

const InputWrapper = styled("div")(({theme}) => ({
    padding: "2px 4px",
    border: `solid 2px ${theme.palette.disabled.contrastText}`,
    display: "flex",
    borderRadius: theme.shape.borderRadius,
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
}));
const LabelComponent = styled("div")(({theme}) => ({
    display: "flex",
    // justifyContent: 'space-between',
    // width: '150px',
    marginBottom: "10px",
}));

const ValueAddedTaxInput = ({}: {}) => {
    const formikContext = useFormikContext();
    const {values} = formikContext;

    // @ts-ignore
    const taxRate = parseInt(values?.taxRate) || 0;

    const changeTaxRate = (flag: 1 | -1) => {
        if (taxRate >= 0) return formikContext.setFieldValue("taxRate", (Number(taxRate) + flag).toString());
    };
    return (
        <>
            <LabelComponent>
                <Typography variant="body2">مالیات بر ارزش افزوده</Typography>
            </LabelComponent>
            <InputWrapper>
                <IconButton onClick={() => changeTaxRate(+1)}>
                    <SimpleAddIcon/>
                </IconButton>
                <Typography variant="body1" sx={{width: "20px"}}>
                    {`${taxRate}%`}
                </Typography>
                <IconButton onClick={() => changeTaxRate(-1)}>
                    <MinusIcon/>
                </IconButton>
            </InputWrapper>
        </>
    );
};

export default ValueAddedTaxInput;
